"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteLowStockNotification = exports.addLowStockNotification = exports.getLowStockNotifications = void 0;
const shared_1 = require("@getgreenline/shared");
const getLowStockNotifications = (companyId) => __awaiter(void 0, void 0, void 0, function* () {
    return shared_1.axios
        .get(`/api/v1/company/${companyId}/user/me/lowStockNotifications`)
        .then((response) => {
        return response.data.data;
    });
});
exports.getLowStockNotifications = getLowStockNotifications;
const addLowStockNotification = (companyId, createObject) => __awaiter(void 0, void 0, void 0, function* () {
    return shared_1.axios
        .post(`/api/v1/company/${companyId}/user/me/lowStockNotifications`, createObject)
        .then((response) => {
        return response.data;
    });
});
exports.addLowStockNotification = addLowStockNotification;
const deleteLowStockNotification = (companyId, lowStockNotificationRecipientId) => {
    return shared_1.axios.delete(`/api/v1/company/${companyId}/user/me/lowStockNotification/${lowStockNotificationRecipientId}`);
};
exports.deleteLowStockNotification = deleteLowStockNotification;
//# sourceMappingURL=low-stock-notifications.js.map